import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import {
  Card,
  CardMedia,
  CardContent,
  CardActionArea,
  Grid,
  Typography
} from '@mui/material';

const Report = ({ pageUrl, imageUrl, title }) => {
  return (
    <Grid
      size={{
        xs: 4,
        sm: 4,
        md: 4,
        lg: 3
      }}
    >
      <Card
        variant="outlined"
        sx={{
          height: '100%',
          color: 'primary.main',
          '&:hover': {
            textDecoration: 'underline'
          }
        }}
      >
        <CardActionArea
          component={RouterLink}
          to={pageUrl}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignContent: 'center',
            justifyContent: 'space-between',
            height: '100%',
            py: 2
          }}
        >
          <CardMedia
            component="img"
            sx={{ width: 'auto' }}
            image={imageUrl}
            alt={`${title} report`}
          />
          <CardContent>
            <Typography variant="containerTitle">{title}</Typography>
          </CardContent>
        </CardActionArea>
      </Card>
    </Grid>
  );
};

export default Report;
